var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"centerWidth",style:({ 'display': _vm.isTab == 2 ? 'none' : '' })},[_vm._m(0)]),_c('div',[_c('keep-alive',{attrs:{"include":"three-page","max":20}},[_c(_vm.cmpName,{key:_vm.selectId,tag:"component"})],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"xtianbao_h1"},[_c('div',{staticClass:"my-title"},[_vm._v("一键智能填报")])])
}]

export { render, staticRenderFns }